module.exports = __webpack_public_path__ + "img/illustrator-somethingWrong.0fd00e8d.svg";